module.exports = __webpack_public_path__ + "img/stuck_out_tongue_closed_eyes.98a11d0f.png";